export const JWT_API = {
    secret: 'SECRET-KEY',
    timeout: '1 days'
};

export const FIREBASE_API = {
    apiKey: 'AIzaSyAknwSvVQLn-ElHP12ZlGRMjo6aRKdlJro',
    authDomain: 'teedovey.firebaseapp.com',
    projectId: 'teedovey',
    storageBucket: 'teedovey.appspot.com',
    messagingSenderId: '53676880450',
    appId: '1:53676880450:web:01e2c502f0a32029b5b3db',
    measurementId: 'G-ETWEXB0GXZ'
};

export const AUTH0_API = {
    client_id: '7T4IlWis4DKHSbG8JAye4Ipk0rvXkH9V',
    domain: 'dev-w0-vxep3.us.auth0.com'
};

export const AWS_API = {
    poolId: 'us-east-1_AOfOTXLvD',
    appClientId: '3eau2osduslvb7vks3vsh9t7b0'
};

// basename: only at build time to set, and Don't add '/' at end off BASENAME for breadcrumbs, also Don't put only '/' use blank('') instead,
// like '/berry-material-react/react/default'
export const BASE_PATH = '';

export const DASHBOARD_PATH = '/dashboard/catalog';

let BACKEND_SERVER = null;
let HOSTNAME = null;
if (process.env.REACT_APP_BACKEND_SERVER) {
    HOSTNAME = process.env.REACT_APP_HOSTNAME;
    BACKEND_SERVER = process.env.REACT_APP_BACKEND_SERVER;
} else {
    BACKEND_SERVER = 'http://127.0.0.1:8000/api/';
}

export const config = {
    fontFamily: `'Poppins', sans-serif`,
    borderRadius: 8,
    outlinedFilled: true,
    navType: 'light', // light, dark
    presetColor: 'theme2', // default, theme1, theme2, theme3, theme4, theme5, theme6
    locale: 'en', // 'en' - English, 'fr' - French, 'ro' - Romanian, 'zh' - Chinese
    rtlLayout: false,
    container: false,
    basename: '',
    defaultPath: '/dashboard/catalog',
    APP_HOSTNAME: HOSTNAME,
    API_SERVER: BACKEND_SERVER,
    STRIPE: process.env.REACT_APP_STRIPE
};

export default config;
